import { cn } from '@/lib/utils';
import { MASK_PROPS } from '@/lib/analytics';

interface CountBadgeProps {
  count: number;
  className?: string;
}

/**
 * Small numeric count pill (notification bell, tab/list counters). Renders
 * nothing when `count` is 0 or less, and is aria-hidden — surface the number in
 * the host control's accessible label instead. Defaults to a muted tone; pass
 * `className` to recolor (tailwind-merge overrides the base bg/text) or
 * reposition.
 */
export function CountBadge({ count, className }: CountBadgeProps) {
  if (count <= 0) return null;
  return (
    <span
      aria-hidden
      // A count is API-fed; stays masked even inside unmasked chrome.
      {...MASK_PROPS}
      className={cn(
        'bg-background-strong text-long-secondary inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold',
        className
      )}
    >
      {count}
    </span>
  );
}
